/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PrincipalRolesControllerFindEligiblePrincipalsQueryResponse, PrincipalRolesControllerFindEligiblePrincipalsQueryParams, PrincipalRolesControllerFindEligiblePrincipals401, PrincipalRolesControllerFindEligiblePrincipals403 } from "../../models/principalRolesController/PrincipalRolesControllerFindEligiblePrincipals";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { principalRolesControllerFindEligiblePrincipals } from "../../clients/principal-rolesService/principalRolesControllerFindEligiblePrincipals";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const principalRolesControllerFindEligiblePrincipalsQueryKey = (params: PrincipalRolesControllerFindEligiblePrincipalsQueryParams) => [{
  url: '/api/v1/principal-roles/eligible-principals'
}, ...(params ? [params] : [])] as const;
export type PrincipalRolesControllerFindEligiblePrincipalsQueryKey = ReturnType<typeof principalRolesControllerFindEligiblePrincipalsQueryKey>;
export function principalRolesControllerFindEligiblePrincipalsQueryOptions(params: PrincipalRolesControllerFindEligiblePrincipalsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = principalRolesControllerFindEligiblePrincipalsQueryKey(params);
  return queryOptions<PrincipalRolesControllerFindEligiblePrincipalsQueryResponse, ResponseErrorConfig<PrincipalRolesControllerFindEligiblePrincipals401 | PrincipalRolesControllerFindEligiblePrincipals403>, PrincipalRolesControllerFindEligiblePrincipalsQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return principalRolesControllerFindEligiblePrincipals(params, config);
    }
  });
}

/**
 * @summary Search people eligible to be assigned or mentioned at a scope
 * {@link /api/v1/principal-roles/eligible-principals}
 */
export function usePrincipalRolesControllerFindEligiblePrincipals<TData = PrincipalRolesControllerFindEligiblePrincipalsQueryResponse, TQueryData = PrincipalRolesControllerFindEligiblePrincipalsQueryResponse, TQueryKey extends QueryKey = PrincipalRolesControllerFindEligiblePrincipalsQueryKey>(params: PrincipalRolesControllerFindEligiblePrincipalsQueryParams, options: {
  query?: Partial<QueryObserverOptions<PrincipalRolesControllerFindEligiblePrincipalsQueryResponse, ResponseErrorConfig<PrincipalRolesControllerFindEligiblePrincipals401 | PrincipalRolesControllerFindEligiblePrincipals403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? principalRolesControllerFindEligiblePrincipalsQueryKey(params);
  const query = useQuery({
    ...principalRolesControllerFindEligiblePrincipalsQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PrincipalRolesControllerFindEligiblePrincipals401 | PrincipalRolesControllerFindEligiblePrincipals403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}